export default __webpack_public_path__ + "images/logo-blue-32x32.bc51756058d9639e43294a03b0c381c3.png";